import { Injectable } from '@angular/core';
import { ReleaseLicenseConfiguration } from './release-license-configuration';

@Injectable({
  providedIn: 'root'
})
export class ReleaseLicenseConfigurationService {

  configuration: ReleaseLicenseConfiguration;

  constructor() { }

  loadConfiguration(configuration) {
    configuration ={
      enabled : false
    }
    this.configuration = configuration
  }
}
